<template>
    <div class="m-dailyStudyRank">
        <div class="page-table">
            <div class="page-filter">
                <div class="page-operate">
                    <el-tooltip class="item" effect="dark" content="导出排行榜" placement="top-start" :hide-after="1000">
                        <el-button size="small" @click="exportRank"><i class="nucfont inuc-daochu"></i></el-button>
                    </el-tooltip>
                </div>

                <el-select v-model="type" size="small" placeholder="选择查询时段" @change="getRank" clearable>
                    <el-option label="全部" value="All"></el-option>
                    <el-option label="今天" value="Today"></el-option>
                    <el-option label="昨天" value="Yesterday"></el-option>
                    <el-option label="7天内" value="Last7D"></el-option>
                    <el-option label="30天内" value="Last30D"></el-option>
                    <el-option label="本月" value="ThisMonth"></el-option>
                    <el-option label="本季度" value="ThisSeason"></el-option>
                    <el-option label="全年" value="ThisYear"></el-option>
                </el-select>
            </div>

            <data-tables class="form-table"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page="1"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" label="排名" width="60" align="center"></el-table-column>

                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 align="center"
                                 :width="title.width" :min-width="title.minWidth"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>
            </data-tables>
        </div>
    </div>
</template>

<script>
import {downloadFile} from "@/utils/file"

export default {
    components: {},

    data() {
        return {
            tableData: [],
            tableProps: {
                border: true,
                stripe: true,
                height: 'auto'
            },
            titles: [
                {
                    prop: 'userName',
                    label: this.$t('c.username')
                },
                {
                    prop: 'accountNo',
                    label: this.$t('c.account')
                },
                {
                    prop: 'orgName',
                    label: this.$t('c.belong')
                },
                {
                    prop: 'credit',
                    label: this.$t('train.credit')
                },
            ],
            type: 'All'
        }
    },

    computed: {},

    mounted() {
        this.getRank()
    },

    methods: {
        getRank() {
            let queryData = {
                type: this.type
            }

            this.$api.getDailyStudyRank(queryData).then(res => {
                let data = res.package
                this.tableData = data.tops
            })
        },

        exportRank() {
            downloadFile('api/DailyIStudy/Export', {
                type: this.type
            })
        }
    },
}
</script>

<style lang="scss">
.m-dailyStudyRank {
    display: flex;
    flex-direction: column;
    height: 100%;

    .page-table {
        box-shadow: none;
    }

    .page-filter {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 17px;
    }
}
</style>
